import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { MainCardRoutingModal } from 'components/common/MainCardRoutingModal/mainCardRoutingModal';
import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { PageWidgetWrapper } from 'components/common/PageWidgetWrapper/PageWidgetWrapper';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { riskConfig } from 'components/Dashboards/ExcellenceApps/riskConfig';
import { TreeProgramTopHeader, VersionCompareSelectorWrapper } from 'components/common';
import { RecommendationsTable } from 'components/widgets/Recommendations/recommendationsTable';

export const RecommendationsPage = () => {
    useFullStoryPageView({ pageName: riskConfig.kcRecommendations.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TreeProgramTopHeader>
                            <VersionCompareSelectorWrapper allowSingleVersion={true} isBaselineSelected={true} />
                        </TreeProgramTopHeader>
                    </VersionSection>
                </VersionWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={riskConfig.kcRecommendations.title} />
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <PageWidgetWrapper>
                    <RecommendationsTable />
                </PageWidgetWrapper>
            </MainContent>

            <MainCardRoutingModal queryKeys={['recomendationTableData']} />
        </PageContainer>
    );
};
